import React, { useEffect } from 'react';

const Notification = ({ message, onClose, duration = 4000 }) => {
  useEffect(() => {
    if (message) {
      const timer = setTimeout(onClose, duration);
      return () => clearTimeout(timer);
    }
  }, [message, onClose, duration]);

  if (!message) return null;

  return (
    <div style={{
      position: 'fixed',
      top: 20,
      right: 20,
      backgroundColor: '#1e1e32',
      border: '1px solid #10b981',
      borderRadius: 12,
      padding: '16px 24px',
      color: '#f3f4f6',
      fontSize: 14,
      zIndex: 2000,
      boxShadow: '0 8px 32px rgba(0,0,0,0.5)',
      maxWidth: 400,
      display: 'flex',
      alignItems: 'center',
      gap: 12
    }}>
      <span style={{ color: '#10b981', fontSize: 18 }}>{'\u2713'}</span>
      <span>{message}</span>
      <button
        onClick={onClose}
        style={{
          background: 'none',
          border: 'none',
          color: '#6b7280',
          fontSize: 18,
          cursor: 'pointer',
          marginLeft: 8
        }}
      >{'\u00D7'}</button>
    </div>
  );
};

export default Notification;
